import React, { Component } from "react";
import { Navbar, Nav, NavItem, MenuItem, Form, FormGroup, FormControl, Button, NavDropdown } from 'react-bootstrap'
import { Link } from "react-router-dom"
import { connect } from 'react-redux'
import NavbarCart from './navbar_cart'
import { fetchSearchInput, fetchProducts, changeSearchLabel, setLoadingSearchPage, setProductsReducer } from '../actions'
import { cuttingLongNameText } from '../utils'
import NavBarMobile from './navBarMobile'
import NavBarMobileBusiness from './navBarMobileBusiness'

var MediaQuery = require('react-responsive');
class NavHeader extends Component {

    state = {
        islogin: localStorage.getItem('user') == null ? false : true,
        searchinput: '',
        count: 1,
        user: JSON.parse(localStorage.getItem('user')),
        transparent: true,
    }


    // {test code}
    handleScroll() {
        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const windowBottom = windowHeight + window.pageYOffset;
        // if (windowBottom < docHeight) {
        //     console.log(windowBottom)
        //     console.log(docHeight)
        // }
        if (windowBottom < 1350) {
            this.setState({ transparent: true })
        }
        else {
            this.setState({ transparent: false })
        }
    }

    // {test code}


    componentWillMount() {
        if (this.props.id != undefined) {
            // console.log('fetchproducts')
            this.props.setLoadingSearchPage(true)
            this.props.changeSearchLabel(this.props.id)
            this.setState({ searchinput: this.props.id })
            this.props.fetchProducts(this.props.id)
        }
        if (localStorage.getItem('user') != null) {
            let user_info = JSON.parse(localStorage.getItem('user'))
            // window.Intercom('shutdown')
            // window.Intercom('boot', {
            //     app_id: 'j77n0bkz',
            //     user_id: user_info.phone_number,
            //     name: user_info.name + ' ' + user_info.lastname,
            // });
        }

    }

    componentWillReceiveProps(nextProps) {
        // console.log('np', nextProps)
        if (nextProps.searchinput != this.state.searchinput && nextProps.products == this.props.products) {
            // console.log('click category')
            this.setState({ searchinput: nextProps.searchinput })
            this.props.setLoadingSearchPage(true)
            this.props.fetchProducts(nextProps.searchinput)
            this.props.changeSearchLabel(nextProps.searchinput)
        }
        if (this.props.id != nextProps.id && this.props.searchinput == nextProps.searchinput && nextProps.id) {
            // console.log('click back forward')
            this.setState({ searchinput: nextProps.id })
            this.props.setLoadingSearchPage(true)
            this.props.fetchProducts(nextProps.id)
            this.props.changeSearchLabel(nextProps.id)
        }
    }

    componentDidMount() {
        // window.addEventListener('scroll', this.handleScroll)

        window.addEventListener("scroll", this.handleScroll.bind(this));
    }

    componentWillUnmount() {
        clearInterval(this.timer)

        window.removeEventListener("scroll", this.handleScroll.bind(this));
    }

    onLoginClicked() {
        this.props.history.push('/login')
    }

    onLogOut() {
        // window.Intercom('shutdown')
        // window.Intercom('boot', {
        //     app_id: 'j77n0bkz',
        // });
        localStorage.removeItem('user')
        this.props.history.push('/login')
    }

    startTimer() {
        this.setState({ count: 1 })
        clearInterval(this.timer)
        this.timer = setInterval(this.tick.bind(this), 1000)
    }

    tick() {
        this.setState({ count: (this.state.count - 1) })
        this.state.count == 0 ? this.timeout() : ''
    }

    timeout() {
        clearInterval(this.timer)
        this.setState({ count: 1 })
        this.props.fetchSearchInput(this.state.searchinput)
        if (this.state.searchinput) {
            this.props.history.push('/search/' + this.state.searchinput)
            this.props.fetchProducts(this.state.searchinput)
        } else {
            this.props.history.push('/')
        }
    }

    handleChange(e) {
        this.props.setLoadingSearchPage(true)
        this.setState({ searchinput: e })
        this.props.changeSearchLabel(e)
        this.props.setProductsReducer()
        this.startTimer()
    }

    onClear() {
        // this.props.fetchSearchInput('')
        this.props.fetchProducts()
        this.props.history.push('/')
    }

    rendermobilecart() {
        return (
            <span className="glyphicon glyphicon-shopping-cart mobile-cart" style={{ color: 'white', fontSize: 20 }}><span className="badge-cart"></span></span>
        )
    }

    render() {
        return (
            <div className='sth'>
                <Navbar className={`navbar-default-business navbar-fixed-top hidden-xs ${this.state.transparent ? 'business-tran' : 'business-black'}`} >
                    <div className="row" >
                        <div className="header-logo" style={{ paddingTop: 4 }}>
                            <div className="navbar-brand" >
                                <a href="/">
                                    <img src="../../static/images/logo_black_white.png" />
                                </a>
                            </div>
                        </div>
                        <div>
                            <Nav>
                                <NavItem eventKey={1} onClick={() => { this.props.history.push('/#service') }}><div className="white-text-navbar-business"><span aria-hidden="true"></span> บริการสินค้าราคาส่ง</div></NavItem>
                                <NavItem eventKey={2} onClick={() => { this.props.history.push('/#guarantee') }}><div className="white-text-navbar-business"><span aria-hidden="true"></span> การรับประกันคุณภาพ</div></NavItem>
                                <NavItem eventKey={3} onClick={() => { this.props.history.push('/#transport') }}><div className="white-text-navbar-business"><span aria-hidden="true"></span> บริการขนส่ง</div></NavItem>
                                <NavItem eventKey={4} onClick={() => { this.props.history.push('/#payment') }}><div className="white-text-navbar-business"><span aria-hidden="true"></span> ช่องทางชำระเงิน</div></NavItem>
                                {/* <NavItem eventKey={5} onClick={() => { this.props.history.push('/') }}><div className="white-text-navbar-business"><span aria-hidden="true"></span> เงื่อนไขการให้บริการ</div></NavItem> */}
                            </Nav>
                        </div>
                    </div>
                </Navbar>
                <div className='navbar-hamburger-menu'>
                    {/* <div className='hidden-sm hidden-md hidden-lg'> */}
                    <NavBarMobileBusiness history={this.props.history} id={this.props.id} />
                    {/* </div> */}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        searchinput: state.searchinput,
        products: state.products,
    };
}




export default connect(mapStateToProps, { fetchSearchInput, fetchProducts, changeSearchLabel, setLoadingSearchPage, setProductsReducer })(NavHeader)


// WEBPACK FOOTER //
// ./src/components/navbusiness.js